/* WaveWear 카드 퀵애드 (ww-card-qa.js) — 2026-09-15
 *
 * 목록 카드에는 담기 버튼 하나만 보이고, 누르면 그 카드 안에서 사이즈 칸이 펼쳐집니다.
 *
 *   1) 평소          [ADD TO CART] 버튼만
 *   2) 버튼을 누르면   사이즈 칸이 펼쳐지고 버튼 글자가 "SELECT SIZE" 로 바뀝니다
 *   3) 사이즈를 고르면 버튼이 "ADD TO CART · S" 로 풀립니다
 *   4) 다시 누르면    그 자리에서 담기고 초록 "Added" → 칸이 접힙니다
 *
 * 일부러 아무 사이즈도 미리 골라 두지 않습니다. 컴프레션 제품은 치수를 보고 골라야 해서
 * 미리 골라 두면 잘못 담길 수 있기 때문입니다.
 *
 * 이 파일이 로드되지 않거나 자바스크립트가 막히면 칸을 접는 CSS 자체가 안 들어가므로,
 * 칸이 처음부터 펼쳐진 채로 나오고 평범한 <form> 제출로 담깁니다(예전 방식 그대로).
 *
 * 스니펫이 카드마다 <script src> 를 한 줄씩 넣기 때문에 이 파일은 여러 번 실행될 수 있습니다.
 * 아래 __wwQa 표시로 첫 번째만 실제로 돌게 막습니다.
 */
(function () {
  if (window.__wwQa) return;
  window.__wwQa = 1;

  var CSS = [
    /* Dawn 카드는 제목 링크의 ::after 가 카드 전체를 덮어 클릭을 가로챕니다.
       옵션과 버튼이 눌리려면 그 위로 올라와야 합니다. */
    '.ww-qa{position:relative;z-index:3;margin-top:1.6rem}',
    '.ww-qa__panel{display:none}',
    '.ww-qa.is-open .ww-qa__panel{display:block;margin-top:.2rem;padding-top:1.1rem;border-top:1px solid rgba(var(--color-foreground),.14)}',
    '.ww-qa__row+.ww-qa__row{margin-top:.9rem}',
    '.ww-qa__lbl{display:block;margin-bottom:.5rem;font-size:1.1rem;line-height:1.3;color:rgba(var(--color-foreground),.55)}',
    '.ww-qa__lbl b{font-weight:500;color:rgba(var(--color-foreground),.9)}',
    '.ww-qa__vals{display:flex;flex-wrap:wrap;gap:.5rem}',
    /* 손가락으로 누를 칸. 기준 화면이 모바일이라 36px 높이를 최소로 잡았습니다. */
    '.ww-qa__box{min-width:3.4rem;min-height:3.6rem;padding:.5rem .6rem;border:1px solid rgba(var(--color-foreground),.22);border-radius:0;font-family:inherit;font-size:1.2rem;line-height:1.2;text-align:center;color:inherit;background:transparent;cursor:pointer}',
    '.ww-qa__box:hover:not(:disabled){border-color:rgba(var(--color-foreground),.6)}',
    '.ww-qa__box.is-on{border-color:rgb(var(--color-foreground));box-shadow:inset 0 0 0 1px rgb(var(--color-foreground));font-weight:600}',
    '.ww-qa__box.is-off,.ww-qa__box:disabled{opacity:.3;text-decoration:line-through;cursor:not-allowed}',
    '.ww-qa__sw{display:block;width:2.4rem;height:2.4rem;padding:0;border-radius:50%;background-color:#ddd;background-size:cover;background-position:center;border:1px solid rgba(var(--color-foreground),.2);cursor:pointer}',
    '.ww-qa__sw.is-on{box-shadow:0 0 0 2px rgb(var(--color-background)),0 0 0 3px rgb(var(--color-foreground))}',
    '.ww-qa__btn{display:block;width:100%;margin-top:1.4rem;padding:1.1rem 1.2rem;border:1px solid rgb(var(--color-foreground));background:rgb(var(--color-foreground));color:rgb(var(--color-background));font-family:inherit;font-size:1.25rem;font-weight:600;letter-spacing:.06em;text-transform:uppercase;cursor:pointer;transition:opacity .15s ease}',
    '.ww-qa.is-open .ww-qa__btn{margin-top:1.1rem}',
    '.ww-qa__btn:hover:not(:disabled):not(.is-wait){opacity:.82}',
    '.ww-qa__btn:disabled{background:transparent;color:rgba(var(--color-foreground),.4);border-color:rgba(var(--color-foreground),.25);cursor:not-allowed}',
    /* 아직 사이즈를 안 고른 상태. 눌러도 담기지 않고, 한 번 더 누르면 칸이 접힙니다. */
    '.ww-qa__btn.is-wait{background:transparent;color:rgba(var(--color-foreground),.55);border-color:rgba(var(--color-foreground),.3)}',
    '.ww-qa__btn.is-busy{opacity:.6;cursor:progress}',
    '.ww-qa__btn.is-done{background:#1E7B45;border-color:#1E7B45;color:#fff}',
    '@media screen and (max-width:749px){',
    '.ww-qa__box{min-width:3.2rem;font-size:1.15rem}',
    '.ww-qa__sw{width:2.1rem;height:2.1rem}',
    '.ww-qa__btn{padding:1rem;font-size:1.15rem}',
    '}'
  ].join('');

  function injectCss() {
    if (document.getElementById('ww-qa-css')) return;
    var st = document.createElement('style');
    st.id = 'ww-qa-css';
    st.textContent = CSS;
    (document.head || document.documentElement).appendChild(st);
  }

  function optOf(v, pos) {
    return pos === 1 ? v.o1 : (pos === 2 ? v.o2 : (pos === 3 ? v.o3 : null));
  }

  // 한 번에 한 카드만 펼칩니다. 여러 장이 동시에 열리면 목록이 다시 어지러워집니다.
  var openBox = null;
  function closeOpen() {
    if (openBox) {
      openBox.classList.remove('is-open');
      if (openBox.__wwLabel) openBox.__wwLabel();
      openBox = null;
    }
  }

  function setup(box) {
    if (box.__wwDone) return;
    box.__wwDone = 1;

    var dataEl = box.querySelector('[data-ww-qa-variants]');
    var vid = box.querySelector('[data-ww-qa-vid]');
    var btn = box.querySelector('[data-ww-qa-btn]');
    var panel = box.querySelector('[data-ww-qa-panel]');
    var form = box.querySelector('[data-ww-qa-form]');
    var cp = parseInt(box.getAttribute('data-color-pos') || '0', 10);
    var sp = parseInt(box.getAttribute('data-size-pos') || '0', 10);
    var varies = box.getAttribute('data-varies') === '1';
    var info = box.closest('.card__information');
    var priceEl = (varies && info) ? info.querySelector('.ww-card__meta .price-item--regular') : null;
    var hardOff = btn ? btn.hasAttribute('data-hard-off') : false;

    var vars = [];
    if (dataEl) {
      try { vars = JSON.parse(dataEl.textContent); } catch (e) { vars = []; }
    }

    // 펼칠 칸이 실제로 있는 카드만 퀵애드로 굴립니다.
    var qa = !!(panel && btn) && box.getAttribute('data-ww-qa-panel-on') === '1';

    // 고를 칸이 있는 옵션 자리만 모읍니다.
    var req = [];
    box.querySelectorAll('[data-ww-qa-opt]').forEach(function (b) {
      var p = b.getAttribute('data-ww-qa-opt');
      if (req.indexOf(p) < 0) req.push(p);
    });

    var baseColor = box.getAttribute('data-base-color') || '';
    var sel = {};

    function seed() {
      sel = {};
      // 색이 하나뿐이라 색 칸을 안 그린 상품은, 그 색을 고른 것으로 칩니다.
      // (이게 없으면 사이즈 재고 판정이 전부 품절로 나옵니다.)
      if (cp > 0 && req.indexOf(String(cp)) < 0 && baseColor) sel[cp] = baseColor;
    }

    function chosen() {
      return req.every(function (p) { return sel[p] != null && sel[p] !== ''; });
    }

    function match() {
      return vars.filter(function (v) {
        return Object.keys(sel).every(function (pos) {
          return optOf(v, parseInt(pos, 10)) === sel[pos];
        });
      })[0];
    }

    function label() {
      if (!btn) return;
      if (hardOff) { btn.textContent = btn.getAttribute('data-soldout'); return; }
      if (qa && box.classList.contains('is-open') && !chosen()) {
        btn.classList.add('is-wait');
        btn.textContent = btn.getAttribute('data-pick') || btn.getAttribute('data-label');
        return;
      }
      btn.classList.remove('is-wait');
      // 접혀 있는 카드는 언제나 기본 글자만 보입니다. 목록이 조용해야 하니까요.
      // (고른 사이즈는 그대로 기억하고 있고, 다시 펼치면 그 칸이 골라진 채로 나옵니다.)
      if (qa && !box.classList.contains('is-open')) { btn.textContent = btn.getAttribute('data-label'); return; }
      var v = (qa && !chosen()) ? null : match();
      if (qa && !chosen()) { btn.textContent = btn.getAttribute('data-label'); return; }
      if (!v || !v.av) { btn.textContent = btn.getAttribute('data-soldout'); return; }
      var picked = sp ? sel[sp] : null;
      btn.textContent = picked ? (btn.getAttribute('data-label') + ' · ' + picked) : btn.getAttribute('data-label');
    }
    box.__wwLabel = label;

    function refresh() {
      if (sp && cp && sel[cp] != null) {
        box.querySelectorAll('[data-ww-qa-opt="' + sp + '"]').forEach(function (b) {
          var okv = vars.some(function (v) {
            return optOf(v, sp) === b.getAttribute('data-ww-qa-val') && optOf(v, cp) === sel[cp] && v.av;
          });
          b.disabled = !okv;
          b.classList.toggle('is-off', !okv);
        });
      }
      var v = (qa && !chosen()) ? null : match();
      if (v && vid) vid.value = v.id;
      if (priceEl && v && v.p) priceEl.textContent = v.p;
      if (btn) {
        btn.disabled = hardOff ? true : (qa ? false : (vars.length ? !(v && v.av) : false));
        btn.classList.remove('is-done');
        label();
      }
    }

    function reset() {
      seed();
      box.querySelectorAll('[data-ww-qa-opt]').forEach(function (o) { o.classList.remove('is-on'); });
      box.querySelectorAll('[data-ww-qa-lbl]').forEach(function (l) { l.textContent = ''; });
      refresh();
    }

    box.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-ww-qa-opt]') : null;
      if (!b || b.disabled) return;
      e.preventDefault();
      var pos = b.getAttribute('data-ww-qa-opt');
      sel[pos] = b.getAttribute('data-ww-qa-val');
      box.querySelectorAll('[data-ww-qa-opt="' + pos + '"]').forEach(function (o) {
        o.classList.toggle('is-on', o === b);
      });
      var lbl = box.querySelector('[data-ww-qa-lbl="' + pos + '"]');
      if (lbl) lbl.textContent = b.getAttribute('data-ww-qa-val');
      refresh();
    });

    if (form && btn) {
      form.addEventListener('submit', function (e) {
        if (btn.disabled || hardOff) { e.preventDefault(); return; }

        // 1) 아직 안 펼쳤으면 — 담지 말고 칸을 펼칩니다
        if (qa && !box.classList.contains('is-open')) {
          e.preventDefault();
          closeOpen();
          box.classList.add('is-open');
          openBox = box;
          label();
          return;
        }
        // 2) 펼쳤는데 아직 안 골랐으면 — 한 번 더 누른 것이므로 접습니다
        if (qa && !chosen()) {
          e.preventDefault();
          closeOpen();
          return;
        }
        // 3) 여기부터 진짜 담기. fetch 가 없는 옛 브라우저는 평범한 폼 제출로 넘깁니다
        if (!window.fetch) return;
        e.preventDefault();
        btn.classList.add('is-busy');
        fetch(box.getAttribute('data-cart-add') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(vid.value, 10), quantity: 1 }] })
        }).then(function (r) {
          return r.json().then(function (j) { return { ok: r.ok, j: j }; });
        }).then(function (res) {
          btn.classList.remove('is-busy');
          if (!res.ok) {
            btn.textContent = (res.j && res.j.description) || btn.getAttribute('data-soldout');
            return;
          }
          btn.classList.add('is-done');
          btn.classList.remove('is-wait');
          btn.textContent = box.getAttribute('data-done') || 'Added';
          box.classList.remove('is-open');
          if (openBox === box) openBox = null;
          setTimeout(function () {
            btn.classList.remove('is-done');
            if (qa) reset(); else label();
          }, 2200);
          fetch(window.location.pathname + '?sections=cart-icon-bubble')
            .then(function (r) { return r.json(); })
            .then(function (secs) {
              var html = secs['cart-icon-bubble'];
              var cur = document.getElementById('cart-icon-bubble');
              if (html && cur) {
                var tmp = document.createElement('div');
                tmp.innerHTML = html;
                var next = tmp.querySelector('#cart-icon-bubble');
                if (next) cur.innerHTML = next.innerHTML;
              }
            }).catch(function () {});
        }).catch(function () {
          btn.classList.remove('is-busy');
          form.submit();
        });
      });
    }

    if (qa) reset(); else refresh();
  }

  function init() {
    injectCss();
    document.querySelectorAll('[data-ww-qa-card]').forEach(setup);
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeOpen();
  });
  document.addEventListener('click', function (e) {
    if (openBox && !openBox.contains(e.target)) closeOpen();
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // 탭 전환·정렬로 카드가 다시 그려질 수 있어 한 번 더 훑습니다.
  document.addEventListener('shopify:section:load', init);
  window.setTimeout(init, 1200);
})();